import React, { Component } from "react";
import { BrowserRouter, Switch, Redirect, useLocation } from "react-router-dom";
import { RoutedContent } from "./routes/index";
import { NotificationContainer } from "react-notifications";
import { isLoggedIn } from "./helpers/auth";
import { customFetch } from "./helpers/fetch";
import { CONST_URI_API } from "./helpers/const";

const basePath = process.env.BASE_PATH || "/";

var bgFetcher;

class App extends Component {

  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  async fetchApi() {
    try {
      customFetch("GET", `${CONST_URI_API}home/keepalive`).then((res) => {
        console.log(`Custom fetch ok : ${res}`)
      });
   } catch (e) {
      console.error(e);
   }
 }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    
    this.fetchApi();
    // bgFetcher = setInterval(this.fetchApi, 10000);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
    clearInterval(bgFetcher);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    return (
      <BrowserRouter basename={basePath}>
        <NotificationContainer />
        <RoutedContent height={this.state.height} />
      </BrowserRouter>
    );
  }
}

export default App;
